// Libraries
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://devapp.therealtordesk.com",
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorMessage = error.response?.data || "Something went wrong";
    return Promise.reject(new Error(errorMessage));
  }
);

export default axiosInstance;
